const Stars = ({ stars: propStars, mode, hide = false }) => {
	if (hide && mode !== 'filter') return null;

	const stars = parseFloat(propStars);
	if (!(stars > 0)) return null;

	const keyBase = `${mode === 'filter' ? 'filter' : 'default'}-star-component`;

	const starsArray = Array.from({ length: 5 }, (_, i) => {
		const index = i + 1;
		const className = index <= stars ? 'full' : index - 0.5 === stars ? 'half' : 'empty';

		return <div className={`star ${className}`} key={`${keyBase}-${index}`} />;
	});

	return <div className="stars">{starsArray}</div>;
};

export default Stars;
